import { render, staticRenderFns } from "./opening.vue?vue&type=template&id=3fb03e24&scoped=true&"
import script from "./opening.vue?vue&type=script&lang=js&"
export * from "./opening.vue?vue&type=script&lang=js&"
import style0 from "./opening.vue?vue&type=style&index=0&id=3fb03e24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb03e24",
  null
  
)

export default component.exports